const BASE_API =
  process.env.REACT_APP_BASE_API_URL || 'https://track-api.nov0.net';
const TRACK_ENDPOINT = '/api/track';
const NUMBERS_ENDPOINT = '/api/numbers';
const LOGIN = '/api/login';

export const TRACK_API_ENDPOINT = BASE_API + TRACK_ENDPOINT;
export const NUMBERS_API_ENDPOINT = BASE_API + NUMBERS_ENDPOINT;
export const LOGIN_ENDPOINT = BASE_API + LOGIN;
